export enum ApiErrorType {
	client = 'client',
	clientWithDetails = 'clientWithDetails',
	json = 'json',
	jwt = 'jwt',
	unknown = 'unknown',
	timeout = 'timeout',
}
